<template>
  <b-card
    :class="verticalCenter ? 'vertical-center' : ''"
    :style="{ minHeight: height }"
  >
    <div>
      <b-row>
        <b-col>
          <b-img
            :src="'/static/images/pillars/' + pillar.id + '_icon_grey1.svg'"
            center
          />
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col>
          <h4>{{ $t(pillar.acronym) }} - {{ $t(pillar.name) }}</h4>
          <p class="card-text">
            {{ $t(pillar.description) }}
          </p>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardPillarInfoConsolidated",
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    height: {
      type: String,
      default: "auto",
    },
    verticalCenter: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      pillar: {},
    };
  },
  computed: mapGetters(["pillarDataConsolidated"]),
  watch: {
    pillarId: function () {
      this.pillar = this.pillarDataConsolidated(this.pillarId);
    },
  },
  mounted() {
    this.pillar = this.pillarDataConsolidated(this.pillarId);
    this.$store.watch(this.$store.getters.pillarDataConsolidated, () => {
      this.pillar = this.pillarDataConsolidated(this.pillarId);
    });
  },
};
</script>

<style lang="sass" scoped>

h4
  text-align: center
img
  margin: 15px 0
  max-width: 130px
  width: 100%

p
  margin: 0 35px
</style>
